import type { Location } from 'react-router';

/** Router state that `RequireAuth` attaches when it sends a visitor to `/login`. */
export interface LoginRedirectState {
  from: Pick<Location, 'pathname' | 'search' | 'hash'>;
}

function isRedirectState(state: unknown): state is LoginRedirectState {
  if (typeof state !== 'object' || state === null || !('from' in state)) return false;
  const { from } = state;
  return typeof from === 'object' && from !== null && 'pathname' in from && typeof from.pathname === 'string';
}

/** Where to land after sign-in: the protected page that sent the user to `/login`, else the dashboard. */
export function postLoginPath(state: unknown): string {
  if (!isRedirectState(state)) return '/';
  const { pathname, search, hash } = state.from;
  // Only same-app absolute paths; never bounce back to the login page itself.
  if (!pathname.startsWith('/') || pathname.startsWith('//') || pathname.startsWith('/login')) return '/';
  return `${pathname}${typeof search === 'string' ? search : ''}${typeof hash === 'string' ? hash : ''}`;
}
